import React from 'react';
import { Target, Users, ShieldCheck, Leaf } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function CompanyBackground() {
  const {
    t
  } = useLanguage();
  const objectives = [{
    icon: Target,
    title: t.companyBackground.objectives.enhance.title,
    description: t.companyBackground.objectives.enhance.description
  }, {
    icon: Users,
    title: t.companyBackground.objectives.bridge.title,
    description: t.companyBackground.objectives.bridge.description
  }, {
    icon: ShieldCheck,
    title: t.companyBackground.objectives.promote.title,
    description: t.companyBackground.objectives.promote.description
  }];
  return <section className="w-full py-16 md:py-24 bg-gray-50" data-id="element-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-4">
          <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4" data-id="element-5">
            {t.companyBackground.badge}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-6">
            {t.companyBackground.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-7">
            {t.companyBackground.subtitle}
          </p>
        </div>

        {/* Objectives Grid */}
        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mb-12" data-id="element-8">
          {objectives.map((item, index) => <div key={index} className="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100" data-id="element-9">
              <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center mb-5" data-id="element-10">
                <item.icon className="w-7 h-7 text-emerald-700" data-id="element-11" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-12">
                {item.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-13">
                {item.description}
              </p>
            </div>)}
        </div>

        {/* GCG Note */}
        <div className="bg-emerald-700 rounded-2xl p-6 md:p-8 text-center" data-id="element-14">
          <div className="flex items-center justify-center gap-3 mb-3" data-id="element-15">
            <Leaf className="w-6 h-6 text-emerald-200" data-id="element-16" />
            <span className="text-emerald-200 font-semibold" data-id="element-17">
              {t.companyBackground.gcg.label}
            </span>
          </div>
          <p className="text-white text-lg max-w-3xl mx-auto" data-id="element-18">
            {t.companyBackground.gcg.text}
          </p>
        </div>
      </div>
    </section>;
}